import React from 'react';
import { cn } from './cn';

const TONE_CLASS = { danger: 'text-bun-danger', success: 'text-bun-success' };

/** Floating summary from Budget.dc.html; values and actions are supplied by the caller. */
export default function SummaryBar({ items, actions, status, feedback, mobileFixed = false, mobilePrimaryLabel, className, 'aria-label': label = 'Summary', ...props }) {
    return (
        <>
            {mobileFixed && <div aria-hidden="true" className={cn(feedback ? 'h-[calc(160px+env(safe-area-inset-bottom))]' : 'h-[calc(88px+env(safe-area-inset-bottom))]', 'sm:hidden')} />}
            <section
                aria-label={label}
                className={cn(
                    'bottom-[max(12px,env(safe-area-inset-bottom))] z-50 rounded-bun-lg border border-bun-line bg-bun-surface px-[18px] py-3 font-instrument text-bun-text shadow-bun-raise',
                    mobileFixed ? 'fixed inset-x-4 sm:sticky sm:inset-x-auto' : 'sticky',
                    className
                )}
                {...props}
            >
                {feedback && <div className="mb-3">{feedback}</div>}
                <div className={cn('flex gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-6', mobileFixed ? 'items-center' : 'flex-col')}>
                    <dl className={cn('m-0 grid min-w-0 flex-1 gap-3 sm:grid-cols-3 sm:gap-6', mobileFixed ? 'grid-cols-1' : 'grid-cols-3')}>
                        {items.map(({ label: itemLabel, value, detail, tone }) => (
                            <div key={itemLabel} className={cn('min-w-0', mobileFixed && itemLabel !== mobilePrimaryLabel && 'hidden sm:block')}>
                                <dt className="text-bun-label font-semibold uppercase tracking-wide text-bun-stone">{itemLabel}</dt>
                                <dd className={cn('m-0 mt-1 break-words font-semibold tabular-nums', mobileFixed ? 'text-bun-metric sm:text-bun-heading' : 'text-bun-heading', TONE_CLASS[tone])}>
                                    {value}
                                    {detail && <span className={cn('mt-1 text-bun-meta font-normal', TONE_CLASS[tone] || 'text-bun-stone', mobileFixed ? 'hidden sm:block' : 'block')}>{detail}</span>}
                                </dd>
                            </div>
                        ))}
                    </dl>
                    <div className={cn('flex items-center justify-end gap-3', mobileFixed ? 'shrink-0 sm:flex-wrap' : 'flex-wrap')}>
                        {status && <div role="status" aria-live="polite" className={cn('text-bun-meta text-bun-stone', mobileFixed && 'sr-only sm:not-sr-only')}>{status}</div>}
                        {actions}
                    </div>
                </div>
            </section>
        </>
    );
}
